module.exports = __webpack_public_path__ + "static/media/profile-small.e8c0982d.png";